import { AxiosGLobalMessaging } from "../apiConfig";

export const requestApiFactory = {
  $_getRequest(payload) {
    const url = "/messages";
    
    return AxiosGLobalMessaging.post(url, payload);
  },
};
